import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createActionsColumn } from '@app/modules/audit/components/create-actions-column';
import { ShowOnStreamAction } from '@app/modules/audit/components/ShowOnStreamAction';
import { FormattedAdoverlayType } from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { Duration, MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { RowActions } from '../../../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../../../core/stations/hooks/useActiveStation';
import { AdOverlayListing } from './types';

import { Seconds } from '@mi-front/core';
import { MRT_SortingState } from 'material-react-table';
import { useContext } from 'react';
import SortContext from '../../context';
export const AdOverlayList = (p: ReportResultProps<AdOverlayListing>) => {
  const { $t } = useIntl();
  const station = useActiveStation();
  const { formatMessage } = useIntl();
  const { sort, setSort } = useContext(SortContext);
  return (
    <MrtTable
      enableFilters={false}
      manualSorting={true}
      onSortingChange={(s) =>
        setSort(s ? (s as MRT_SortingState) : ([{ id: 'date', desc: false }] as MRT_SortingState))
      }
      columns={[
        createDateTimeColumn<FormattedAdoverlayType>($t, {
          id: 'date',
          accessor: (row) => row.date,
          enableColumnFilter: false,
        }),
        {
          id: 'brand',
          enableGlobalFilter: true,
          enableSorting: true,
          enableColumnFilter: false,
          accessorFn: (row) => row.brand,
          header: formatMessage({
            id: 'audit.adoverlayScreen.brand',
            defaultMessage: 'Marca',
          }),
          Cell: ({ renderedCellValue }) => <div>{renderedCellValue}</div>,
          size: 50,
        },
        {
          id: 'image',
          header: formatMessage({
            id: 'audit.adoverlayScreen.image',
            defaultMessage: 'Imagen',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <img
                src={original.image_b64}
                alt={`${original.brand} ad`}
                style={{ maxWidth: '42rem', height: '6rem' }}
              />
            </div>
          ),
          size: 180,
        },
        {
          id: 'duration',
          accessorFn: (row) => row.duration,
          header: formatMessage({
            id: 'audit.adoverlayScreen.duration',
            defaultMessage: 'Duración',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <Duration seconds={original.duration as Seconds} />
            </div>
          ),
          enableSorting: true,
          size: 30,
        },

        createActionsColumn<FormattedAdoverlayType>($t, {
          size: 80,
          Cell: ({ row }) => (
            <RowActions>
              <ShowOnStreamAction
                station={station.slug}
                datetime={row.original.start_timestamp}
                endDatetime={row.original.end_timestamp}
                tab="adoverlay"
              />
            </RowActions>
          ),
        }),
      ]}
      data={p.result.results}
      state={{
        sorting: sort,
      }}
    />
  );
};
